import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import { getLastTimelineStatus } from '../statusHelper';

import './ShipmentTabs.module.scss';

export class ShipmentTabs extends React.PureComponent {
  onTabClick = (id) => {
    const { selected, onSelect } = this.props;

    if (id !== selected) {
      onSelect(id);
    }
  };

  getTitle = (index, isReturnParcel, sortedShipments) => {
    const { shipmentTabLabel, returnTabLabel } = this.props;

    const firstReturnIndex = sortedShipments.findIndex((shipment) => shipment.isReturnParcel);

    if (!isReturnParcel) {
      return `${shipmentTabLabel} ${index + 1}`;
    } else {
      return `${returnTabLabel} ${index - firstReturnIndex + 1}`;
    }
  };

  render() {
    const { shipments, selected, designSettings } = this.props;

    return (
      <div styleName="shipment-tabs">
        <div styleName="tabs">
          {shipments.map((shipment, index) => {
            const lastStatus = getLastTimelineStatus(shipment.statusTimeline) || shipment.lastEvent;

            return (
              <Tab
                key={index}
                title={this.getTitle(index, shipment.isReturnParcel, shipments)}
                icon={lastStatus.icon}
                selected={index === selected}
                onClick={() => this.onTabClick(index)}
                designSettings={designSettings}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

ShipmentTabs.defaultProps = {
  shipmentTabLabel: 'Shipment',
  returnTabLabel: 'Return',
};

ShipmentTabs.propTypes = {
  shipments: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.number,
  onSelect: PropTypes.func,
  designSettings: PropTypes.object,
  shipmentTabLabel: PropTypes.string,
  returnTabLabel: PropTypes.string,
};

export default ShipmentTabs;
